import { countries } from "@/data"

export const getCountries = () => countries;